/**
 * THIS FILE IS AUTO-GENERATED - DO NOT EDIT
 * 
 * Generated by GraphQL Code Generator with React Query v5 integration
 * Any changes to this file will be overwritten when codegen runs
 * 
 * @generated
 * @see {@link https://the-guild.dev/graphql/codegen}
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable import/order, import/no-duplicates */

import * as Types from '../../../../../../../../generated/types';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { graphqlFetcher } from '~/utils/graphql-fetcher';
export type UserByRowIdQueryVariables = Types.Exact<{
  rowId: Types.Scalars['Int']['input'];
}>;


export type UserByRowIdQueryResult = { __typename?: 'Query', user?: { __typename?: 'User', id: string, rowId: number, email: string, role: string, createdAt: any, updatedAt: any, emailConfirmed?: boolean | null, isLocked?: boolean | null, lockType?: string | null, lockReason?: string | null, needsVerification?: boolean | null, isBot?: boolean | null, kycStatus?: string | null, lastIp?: string | null, discordId?: string | null, discordUsername?: string | null, verificationLastRequestedAt?: any | null, twoFactorEnabled?: boolean | null, projectXUserId?: number | null, projectXPassword?: string | null, netSuiteId?: number | null, accountTotal?: number | null, userContactInfo?: { __typename?: 'UserContactInfo', firstName?: string | null, lastName?: string | null, screenName: string, addressVerification?: string | null, city: string, country: string, state: string, street: string, street2?: string | null, zip: string, phone?: string | null } | null, verifications: { __typename?: 'VerificationConnection', nodes: Array<{ __typename?: 'Verification', riskLabels?: any | null, status?: string | null } | null> }, traderLockDetail?: { __typename?: 'TraderLockDetail', lockedAt: any, lockedById?: number | null, lockNote?: string | null, lockedBy?: { __typename?: 'User', email: string, userContactInfo?: { __typename?: 'UserContactInfo', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null };



export const UserByRowIdDocument = /*#__PURE__*/ `
    query UserByRowId($rowId: Int!) {
  user(rowId: $rowId) {
    id
    rowId
    email
    role
    createdAt
    updatedAt
    emailConfirmed
    isLocked
    lockType
    lockReason
    needsVerification
    isBot
    kycStatus
    lastIp
    discordId
    discordUsername
    verificationLastRequestedAt
    twoFactorEnabled
    projectXUserId
    projectXPassword
    netSuiteId
    accountTotal
    userContactInfo {
      firstName
      lastName
      screenName
      addressVerification
      city
      country
      state
      street
      street2
      zip
      phone
    }
    verifications(orderBy: [ROW_ID_DESC], first: 1) {
      nodes {
        riskLabels
        status
      }
    }
    traderLockDetail {
      lockedAt
      lockedById
      lockNote
      lockedBy {
        email
        userContactInfo {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

export const useUserByRowIdQuery = <
      TData = UserByRowIdQueryResult,
      TError = unknown
    >(
      variables: UserByRowIdQueryVariables,
      options?: Omit<UseQueryOptions<UserByRowIdQueryResult, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserByRowIdQueryResult, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserByRowIdQueryResult, TError, TData>(
      {
    queryKey: ['UserByRowId', variables],
    queryFn: graphqlFetcher<UserByRowIdQueryResult, UserByRowIdQueryVariables>(UserByRowIdDocument, variables),
    ...options
  }
    )};

useUserByRowIdQuery.getKey = (variables: UserByRowIdQueryVariables) => ['UserByRowId', variables];

export const useInfiniteUserByRowIdQuery = <
      TData = InfiniteData<UserByRowIdQueryResult>,
      TError = unknown
    >(
      variables: UserByRowIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserByRowIdQueryResult, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserByRowIdQueryResult, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserByRowIdQueryResult, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserByRowId.infinite', variables],
      queryFn: (metaData) => graphqlFetcher<UserByRowIdQueryResult, UserByRowIdQueryVariables>(UserByRowIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserByRowIdQuery.getKey = (variables: UserByRowIdQueryVariables) => ['UserByRowId.infinite', variables];
